import React from "react";
import { RiMenuLine } from "react-icons/ri";
import LeftPanel from "../components/LeftPanel";
import PanelOverlay from "../components/PanelOverlay";

function PanelsContainer(props) {
  const {
    showLeftPanel,
    setShowLeftPanel,
    leftPanelTab,
    setLeftPanelTab,
    onResetChat,
    isResetting,
    API_URL,
    user,
    activeConversationId,
    onSelectConversation,
    onDeleteConversation,
    onRenameConversation,
    isDeleting,
    isRenaming,
    historyRefreshTrigger,
    loadingConversationIds,
    pendingConversations,
    onHistoriesFetched,
    justCompletedIds,
    swarmSessions,
    pendingSwarmSessions,
    loadingSwarmSessionIds,
    onSelectSwarmSession,
    onDeleteSwarmSession,
    onRenameSwarmSession,
    isDeletingSwarm,
    isRenamingSwarm,
    activeSwarmSessionId,
    swarmSessionsLoading,
    onModeChange,
    activeMode,
    workflowRuns,
    workflowList,
    onRenameWorkflowRun,
    onDeleteWorkflowRun,
    onSelectWorkflowRun,
    activeWorkflowRunId,
    // Settings tab props
    modelSettings,
    theme,
    toggleTheme,
    selectedApis,
    setSelectedApis,
    refreshHistories,
    resetMainPanel,
    refreshModelSettings,
  } = props;

  const openConversations = () => {
    setLeftPanelTab("conversations");
    setShowLeftPanel(true);
  };

  return (
    <>
      <button
        className="show-panel-btn left"
        onClick={openConversations}
        aria-label="Open menu"
        style={{ padding: '0.5rem', lineHeight: 0 }}
      >
        <RiMenuLine size={20} />
      </button>

      {showLeftPanel && (
        <PanelOverlay side="left" onClose={() => setShowLeftPanel(false)}>
          <LeftPanel
            scrollAreaStyle={{ flex: 1, overflowY: "auto", minHeight: 0 }}
            API_URL={API_URL}
            user={user}
            activeConversationId={activeConversationId}
            onSelectConversation={(id) => { onSelectConversation(id); setShowLeftPanel(false); }}
            onDeleteConversation={onDeleteConversation}
            onRenameConversation={onRenameConversation}
            isDeleting={isDeleting}
            isRenaming={isRenaming}
            onResetChat={onResetChat}
            isResetting={isResetting}
            historyRefreshTrigger={historyRefreshTrigger}
            loadingConversationIds={loadingConversationIds}
            pendingConversations={pendingConversations}
            onHistoriesFetched={onHistoriesFetched}
            justCompletedIds={justCompletedIds}
            swarmSessions={swarmSessions}
            pendingSwarmSessions={pendingSwarmSessions}
            loadingSwarmSessionIds={loadingSwarmSessionIds}
            onSelectSwarmSession={(id) => { onSelectSwarmSession(id); setShowLeftPanel(false); }}
            onDeleteSwarmSession={onDeleteSwarmSession}
            onRenameSwarmSession={onRenameSwarmSession}
            isDeletingSwarm={isDeletingSwarm}
            isRenamingSwarm={isRenamingSwarm}
            activeSwarmSessionId={activeSwarmSessionId}
            swarmSessionsLoading={swarmSessionsLoading}
            onModeChange={onModeChange}
            activeMode={activeMode}
            workflowRuns={workflowRuns}
            workflowList={workflowList}
            onRenameWorkflowRun={onRenameWorkflowRun}
            onDeleteWorkflowRun={onDeleteWorkflowRun}
            onSelectWorkflowRun={(id) => { onSelectWorkflowRun(id); setShowLeftPanel(false); }}
            activeWorkflowRunId={activeWorkflowRunId}
            activeTab={leftPanelTab}
            onTabChange={setLeftPanelTab}
            modelSettings={modelSettings}
            theme={theme}
            toggleTheme={toggleTheme}
            selectedApis={selectedApis}
            setSelectedApis={setSelectedApis}
            refreshHistories={refreshHistories}
            resetMainPanel={resetMainPanel}
            refreshModelSettings={refreshModelSettings}
            onClose={() => setShowLeftPanel(false)}
          />
        </PanelOverlay>
      )}
    </>
  );
}

export default React.memo(PanelsContainer);
